import { timeAgo } from "@/lib/format";
import { useCountdown } from "@/lib/useCountdown";

const STATUS_LABEL = { undertaken: "undertaken", sent_up: "sent up", completed: "completed", failed: "failed", expired: "failed · time ran out" };

function TakenItem({ u, onOpen }) {
  const left = useCountdown(u.status === "undertaken" ? u.deadline : null);
  const active = u.status === "undertaken";
  return (
    <li
      data-testid={`my-undertaking-${u.id}`}
      onClick={active ? () => onOpen(u) : undefined}
      className={`py-5 px-4 fade-in-up ${active ? "cursor-pointer" : ""}`}
      style={{ borderBottom: "1px solid var(--border)", opacity: u.failed_at ? 0.6 : 1 }}
    >
      <div className="flex items-center gap-3 mb-2 flex-wrap">
        <span data-testid={`my-undertaking-status-${u.id}`} className="text-[10px] uppercase tracking-widest px-2 py-1" style={{ border: "1px solid var(--accent)", color: u.status === "completed" ? "#121212" : "var(--accent)", background: u.status === "completed" ? "var(--accent)" : "transparent" }}>
          {STATUS_LABEL[u.status] || u.status}
        </span>
        {active && left && <span className="text-xs tracking-widest" style={{ color: "var(--accent)" }} data-testid={`my-undertaking-clock-${u.id}`}>{left}</span>}
        <span className="text-xs ml-auto" style={{ color: "var(--accent)" }}>{u.provisions} provisions</span>
      </div>
      <p className="long-text-sm text-sm" style={{ color: "var(--text-secondary)" }}>{u.text}</p>
      {u.fail_note && (
        <p className="text-xs mt-2" style={{ color: "var(--accent)" }} data-testid={`my-undertaking-fail-note-${u.id}`}>reason: {u.fail_note}</p>
      )}
      <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>
        delegated by {u.author?.name || "unknown"} · {timeAgo(u.failed_at || u.completed_at || u.sent_up_at || u.accepted_at)}
      </p>
    </li>
  );
}

export function MyUndertakings({ items, onOpen }) {
  return (
    <div className="w-full mt-24" data-testid="my-undertakings">
      <p className="text-xs uppercase tracking-widest mb-4" style={{ color: "var(--text-muted)" }}>your undertakings</p>
      {items.length === 0 ? (
        <p className="text-sm" style={{ color: "var(--text-muted)" }} data-testid="my-undertakings-empty">nothing undertaken yet.</p>
      ) : (
        <ul>{items.map((u) => <TakenItem key={u.id} u={u} onOpen={onOpen} />)}</ul>
      )}
    </div>
  );
}
